import {
  CUSTOMERS_LIST_ROW_DELETE_KEYS,
  CUSTOMERS_LIST_ROW_EXCURSIONS_KEYS,
  CUSTOMERS_LIST_ROW_PRODUCTS_KEYS,
  CUSTOMERS_LIST_ROW_PROFILE_KEYS,
  CUSTOMERS_LIST_ROW_TRAININGS_KEYS,
} from "../../../api/zekay/permissions";
import { usePermissions } from "../../../contexts/app/permissions";

export type CustomersModulePermissions = {
  canOpenProfile: boolean;
  canOpenTrainingsModal: boolean;
  canOpenExcursionsModal: boolean;
  canOpenCustomerProducts: boolean;
  canDeleteCustomer: boolean;
};

export function useCustomersModulePermissions(desyncMode: boolean): CustomersModulePermissions {
  const { hasAnyPermission } = usePermissions();

  const canOpenCustomerProducts =
    Boolean(desyncMode) && hasAnyPermission(CUSTOMERS_LIST_ROW_PRODUCTS_KEYS);

  return {
    canOpenProfile: hasAnyPermission(CUSTOMERS_LIST_ROW_PROFILE_KEYS),
    canOpenTrainingsModal: hasAnyPermission(CUSTOMERS_LIST_ROW_TRAININGS_KEYS),
    canOpenExcursionsModal: hasAnyPermission(CUSTOMERS_LIST_ROW_EXCURSIONS_KEYS),
    canOpenCustomerProducts,
    canDeleteCustomer: desyncMode && hasAnyPermission(CUSTOMERS_LIST_ROW_DELETE_KEYS),
  };
}
